import { CSSProgressiveBody02Semibold } from "@caisy/league";
import styled from "styled-components";

export const SOnboardingTemplatesTemplateName = styled.div`
  ${CSSProgressiveBody02Semibold};
  color: var(--text-01);
`;
